import { createContext, useContext } from 'react';
import type { MutationStatus } from '@tanstack/react-query';

import type { useFairValueModals } from '../hooks/useFairValueModals';

type Modals = ReturnType<typeof useFairValueModals>;
type Mutation = {
  mutation: {
    status: MutationStatus;
    mutate(payload: { fairValue: number }): void;
  };
};

type Context = Modals & Mutation;

const FairValueContext = createContext<Context | null>(null);

export const FairValueProvider = FairValueContext.Provider;

export function useFairValueContext() {
  const context = useContext(FairValueContext);

  if (context) {
    return context;
  }

  throw new Error(
    'Attempted to access FairValueContext outside of a FairValueProvider'
  );
}
